/* app/js/src/components/common/ag-grid-evrideo/ag-grid-evrideo-spinning-wheel/ag-grid-evrideo-spinning-wheel.component.scss */
:host {
  position: relative;
  display: inline-block;
}
.tooltip {
  visibility: hidden;
  background-color: black;
  color: white;
  text-align: center;
  padding: 5px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
}
:host:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
/*# sourceMappingURL=ag-grid-evrideo-spinning-wheel.component.css.map */
